import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

import catalogStore from './catalog';
import comparativeStore from './comparatives';
import uploaderStore from './uploader';
import catalogIntelimotor from './intelimotor'
import centralApi from './centralApi'
import catalogNewVehicle from './catalogNewVehicle';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        catalog: catalogStore,
        comparative: comparativeStore,
        uploader: uploaderStore,
        intelimotor: catalogIntelimotor,
        centralApi: centralApi,
        catalogNewVehicle: catalogNewVehicle
    },
    state: {
        user: {},
    },
    actions: {
        async getAuth({ commit }) {
            let { data } = await axios.get('/auth-user');
            commit('setUser', data);
        }
    },
    mutations: {
        setUser(state, data) {
            state.user = data;
        }
    }
})
